import React, { useCallback, useState } from 'react';
import { ErrorModal } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';
import { SnackbarState } from '@/modules/core/core.types';
import { useSnackbar } from '@/modules/core/hooks';

import { Dependent } from '../../employee.types';

import { AddDependentForm } from './AddDependentForm';
import { SSN_UNIQUE_ERROR_MESSAGE, useSsnConflictError } from './hooks';

interface Props {
  setEditDependentId: React.Dispatch<React.SetStateAction<string>>;
  dependent: Dependent;
}

const EditDependentModal = ({ setEditDependentId, dependent }: Props) => {
  const { handleAddPermanentSnackbar } = useSnackbar();
  const [isSsnConflictVisible, setSsnConflictVisible] = useState(false);
  const handleError = useSsnConflictError({ setSsnConflictVisible });

  const onSuccess = useCallback(() => {
    handleAddPermanentSnackbar({
      text: `${dependent?.firstName} ${dependent?.lastName} was updated successfully!`,
      state: SnackbarState.positive,
      closeIcon: true,
    });
    setEditDependentId('');
  }, [setEditDependentId, handleAddPermanentSnackbar, dependent]);

  return (
    <>
      <ModalWrapper
        visible
        title="Edit a Dependent"
        onSetVisible={() => setEditDependentId('')}
        isClosingByClickOutsideBlocked={isSsnConflictVisible}
      >
        <AddDependentForm
          dependent={dependent}
          onSuccess={onSuccess}
          onError={handleError}
          onCancel={() => setEditDependentId('')}
        />
      </ModalWrapper>
      <ErrorModal
        testId="edit-dependent-ssn-conflict-modal"
        visible={isSsnConflictVisible}
        onSetVisible={setSsnConflictVisible}
        header={SSN_UNIQUE_ERROR_MESSAGE}
        buttonText="Got It!"
      />
    </>
  );
};

export default EditDependentModal;
